export default "__VITE_ASSET__Cbihsij0__"